import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-login",
  "use": "icon-login-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-login\"><path d=\"M11 11v1c0 .6-.4 1-1 1H5c-.6 0-1-.4-1-1V4c0-.6.4-1 1-1h5c.6 0 1 .4 1 1v1h1V4c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h5c1.1 0 2-.9 2-2v-1z\" /><path d=\"m8.3 11.2.7-.7-2-2h8v-1H7l2-2-.7-.7L5.1 8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol